import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const container = document.getElementById('root');

if (container === null) {
  // index.html luon co #root, nen den day nghia la file tinh bi phuc vu sai.
  // Noi thang ra man hinh thay vi de trang trang im lang.
  document.body.textContent = 'Không tìm thấy phần tử #root — kiểm tra lại index.html.';
} else {
  createRoot(container).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
